import {
  CheckCircle2,
  Circle,
  FileCheck,
  Flag,
  MapPinCheck,
  Milestone,
  Package,
  PackagePlus,
  Stamp,
  XCircle,
} from 'lucide-react';
import { TRIP_STATUS_ORDER, getTripPhase } from '../../lib/tripPhases';
import { libelle } from '../../lib/libelles';

// Présentation seulement: l'ordre et le découpage en phases viennent de
// lib/tripPhases.js, pour qu'il n'existe qu'une seule séquence de statuts.
const STATUS_PRESENTATION = {
  CREATED: { label: 'Créé', short: 'Créé', icon: Circle },
  EN_ROUTE_TO_BORDER: { label: 'Vers la frontière', short: 'Frontière', icon: Flag },
  AT_CUSTOMS_EXIT: { label: 'Douane de sortie', short: 'Sortie', icon: Stamp },
  CLEARED_CUSTOMS_EXIT: { label: 'Sortie validée', short: 'Validée', icon: CheckCircle2 },
  EN_ROUTE_TO_LOADING: { label: 'Vers le chargement', short: 'Chargement', icon: PackagePlus },
  LOADING: { label: 'Chargement', short: 'Chargement', icon: Package },
  EN_ROUTE_TO_ENTRY_CUSTOMS: { label: "Vers la douane d'entrée", short: 'Entrée', icon: Flag },
  AT_CUSTOMS_ENTRY: { label: "Douane d'entrée", short: 'Douane', icon: Stamp },
  CLEARED_CUSTOMS_ENTRY: { label: 'Entrée validée', short: 'Validée', icon: CheckCircle2 },
  ARRIVED_AT_DEPOT: { label: 'Arrivé au dépôt', short: 'Dépôt', icon: Milestone },
  EN_ROUTE_TO_DELIVERY: { label: 'Vers la livraison', short: 'Livraison', icon: MapPinCheck },
  DELIVERED: { label: 'Livré', short: 'Livré', icon: FileCheck },
  COMPLETED: { label: 'Clôturé', short: 'Clôturé', icon: CheckCircle2 },
  CANCELLED: { label: 'Annulé', short: 'Annulé', icon: XCircle },
};

// Le dépôt peut être sauté: la société livre souvent en direct depuis la douane.
export const OPTIONAL_STATUSES = ['ARRIVED_AT_DEPOT'];

export const TRIP_STATUSES = [...TRIP_STATUS_ORDER, 'CANCELLED'].map((key) => ({
  key,
  phase: getTripPhase(key),
  optional: OPTIONAL_STATUSES.includes(key),
  ...(STATUS_PRESENTATION[key] || { label: libelle('tripStatus', key), short: libelle('tripStatus', key), icon: Circle }),
}));
